import { Box, Button, Grid, Link, Typography, useTheme } from '@mui/material';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ButtonCTAOnboarding from './components/ButtonCTAOnboarding';
import OnboardingInput from './components/OnboardingInput';
import TestimonialsCarousel from './components/TestimonialsCarousel';

const testimonials = [
  {
    name: 'Derek Taylor',
    title: 'Director of Technology, Implementation and Operations, T3 Sixty',
    avatar: 'https://randomuser.me/api/portraits/men/32.jpg',
    quote:
      '"In evaluating countless real estate platforms, Oppy stands out. Its intelligent lead engagement maintains the crucial personal touch while revolutionizing prospect management. Our clients\' agents can focus on closing deals while Oppy handles the rest."',
  },
  {
    name: 'Leah McNamara',
    title: 'Managing Broker at Best Realty',
    avatar: 'https://randomuser.me/api/portraits/women/44.jpg',
    quote:
      '“Oppy is a game changer for our brokerage. It consistently conducts meaningful conversations with potential clients and customers, saving us countless hours. Their white glove service is the key to our success”',
  },
];

export const LoginOnboarding = () => {
  const navigate = useNavigate();
  const [current, setCurrent] = useState(0);
  const theme = useTheme();

  const handleLogin = () => {
    navigate('/onboarding/v2/phone-number');
  };

  const handlePrev = () => {
    setCurrent((prev) => (prev === 0 ? testimonials.length - 1 : prev - 1));
  };

  const handleNext = () => {
    setCurrent((prev) => (prev === testimonials.length - 1 ? 0 : prev + 1));
  };

  return (
    <Grid container sx={{ minHeight: '100vh' }}>
      <Grid
        item
        xs={12}
        md={6}
        sx={{
          backgroundColor: '#19191C',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          px: 2,
        }}
      >
        <Box
          sx={{
            width: '100%',
            maxWidth: 400,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <img
            src="/icon/artwork.svg"
            alt=""
            style={{
              width: 160,
              height: 'auto',
              marginBottom: 8,
            }}
          />
          <Typography
            color={theme.palette.common.white}
            fontFamily="Space Grotesk"
            variant="h6"
            mt={2}
            mb={3}
          >
            Sign in to Oppy dashboard
          </Typography>
          <Box
            sx={{
              width: { xs: '100%', sm: 350, md: 400 },
              maxWidth: '100%',
              display: 'flex',
              flexDirection: 'column',
              gap: 2,
            }}
          >
            <OnboardingInput
              placeholder="example@oppy.com"
              margin="normal"
              label="Email"
            />
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
                mt: 1,
                mb: 2,
              }}
            >
              <OnboardingInput
                placeholder="Enter your password"
                type="password"
                margin="normal"
                label="Password"
              />

              <Link
                fontSize={16}
                href="#"
                variant="body2"
                color="#4949C8"
                underline="hover"
              >
                Forgot password?
              </Link>
            </Box>
          </Box>
          <ButtonCTAOnboarding label="Sign in" onClick={handleLogin} />
          <Button
            variant="text"
            sx={{
              mt: 2,
              width: { xs: '100%', sm: 350, md: 400 },
              maxWidth: '100%',
              color: '#4949C8',
              fontSize: 16,
              fontWeight: 400,
            }}
          >
            Sign in using phone
          </Button>
          <Typography
            variant="body2"
            mt={3}
            textAlign="center"
            color={theme.palette.common.white}
          >
            Don't have an account yet?{' '}
            <Link href="#" color="#4949C8" underline="hover">
              Start a free trial
            </Link>
          </Typography>
        </Box>
      </Grid>

      <Grid
        item
        xs={12}
        md={6}
        sx={{
          backgroundColor: '#fafafd',
          display: { xs: 'none', md: 'flex' },
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Box sx={{ maxWidth: 500, textAlign: 'center', mb: 0 }}>
          <Typography
            variant="h5"
            fontFamily="Space Grotesk"
            fontWeight={700}
            color="#4949C8"
            sx={{ mb: 1 }}
          >
            Oppy's AI assistants handle <br /> your daily tasks…
          </Typography>
          <Typography variant="subtitle1" color="#222" sx={{ mb: 4 }}>
            so you can focus on showing homes, closing <br /> deals, and
            building relationships.
          </Typography>
        </Box>

        <TestimonialsCarousel />
      </Grid>
    </Grid>
  );
};
